module.exports = __webpack_public_path__ + "assets/img/ydk.742b3b9a.png";